import { render, staticRenderFns } from "./presentationMview.vue?vue&type=template&id=28dbdb5a&"
import script from "./presentationMview.vue?vue&type=script&lang=js&"
export * from "./presentationMview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports